import * as Sentry from '@sentry/nextjs';

import { APIRequestLabel } from '../consts';
import { callHttpGet } from '../http';
import { AccountType } from '../models';

const getAccountProfile = (get, set) => {
  return async (id: string, translator: any) => {
    if (id.toLowerCase() === 'master') {
      set({
        accountProfile: {
          type: AccountType.MASTER,
          user: {
            id: -1,
            name: translator('components.master.name')
          },
          jobTitle: translator('components.master.jobTitle'),
          about: translator('components.master.about'),
          links: [],
          rating: null,
          createdGoalsCount: 0,
          createdGoals: [],
          completedGoalsCount: 0,
          completedGoals: []
        }
      });
    } else {
      await callHttpGet(get, set, APIRequestLabel.GET_ACCOUNT_PROFILE, `/accounts/${id}/profile`);
      let apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_ACCOUNT_PROFILE];
      if (apiCallStatus.error) {
        Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
        return;
      }

      set({ accountProfile: apiCallStatus.response });
    }
  };
};

export { getAccountProfile };
